
import { Alert, Button, Grid, Typography, Container } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useIrAlDestino } from '../../utils/destinoAlEntrar';

const LastStep = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Sin estado (p. ej. si se abre la dirección directo) se muestra como error en vez de romperse
  const estado = location.state || {};
  // Step3 inicia la sesión al crear la cuenta: «Continuar» lleva adonde iba. Si no pudo entrar, «Entrar» lleva al login (que regresa igual)
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const irAlDestino = useIrAlDestino();

  const img = estado.status == 'success'
    ? "/Sticker.png"
    : "/Vector.png";
  const title = estado.status == 'success'
    ? "Cuenta verificada"
    : "Ocurrió un error";
  const subTitle = estado.status == 'success'
    ? "¡Bienvenido!"
    : "¡Upps! ha ocurrido un error intenta de nuevo.";

  return (
    <Container component="main" maxWidth="lg">
      <Grid className="general" container size={12}>
        <Grid className="status" container direction="column" alignItems="center" justifyContent="center" size={6}>
          <img width="150" src={img} alt="Estatus" />
        </Grid>
        <Grid container direction="column" alignItems="center" justifyContent="center">
          <Typography variant="h4">{title}</Typography>
          <Typography variant="h5">{subTitle}</Typography>
          {estado.status == 'success' &&
            <Typography variant="h5">
              Ya eres parte del círculo de servicios One Service
            </Typography>
          }
          {estado.status === 'success' && estado.celularSinConfirmar &&
            <Alert severity="info" sx={{ mt: 2, maxWidth: 520 }}>
              Tu celular quedó sin confirmar. Confírmalo desde tu perfil con un código por SMS para poder recuperar tu contraseña con él.
            </Alert>
          }
          {estado.status === 'success' && !isAuthenticated &&
            <Alert severity="warning" sx={{ mt: 2, maxWidth: 520 }}>
              Tu cuenta ya está creada, pero no pudimos iniciar sesión. Toca «Entrar» y escribe tu correo y tu contraseña.
            </Alert>
          }
        </Grid>
        <Grid size={6} sx={{mt: 3}}>
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            onClick={isAuthenticated ? irAlDestino : () => navigate('/login')}
          >
            {isAuthenticated ? 'Continuar' : 'Entrar'}
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
}

export default LastStep;